export const initialState = {
  isAuth: false,
  isBanned: false,
};
